import { IntegrationCodeEnum } from "./access";

export type CompanyType = "BASIC" | "MAPOS";
export type AgentWorkflow =
  | "NONE"
  | "MAPOS_RESTAURANT"
  | "LOANS"
  | "EXTERNAL_BOT"
  | "LYPRO_TRAVEL";

const ALL_INTEGRATIONS = Object.values(IntegrationCodeEnum);

export const COMPANY_TYPE_OPTIONS: Array<{
  value: CompanyType;
  label: string;
  description: string;
}> = [
  {
    value: "BASIC",
    label: "Compañía básica",
    description: "Sin conexión MAPOS. Usa conversación normal y los módulos Lypro que habilites.",
  },
  {
    value: "MAPOS",
    label: "Compañía con MAPOS",
    description: "Permite credenciales, integración y workflows especializados de MAPOS.",
  },
];

export const COMPANY_TYPE_CAPABILITIES: Record<
  CompanyType,
  { integrations: string[]; workflows: AgentWorkflow[] }
> = {
  BASIC: {
    integrations: ALL_INTEGRATIONS.filter(
      (integration) => integration !== IntegrationCodeEnum.MAPOS_MASTORE,
    ),
    workflows: ["NONE", "LOANS"],
  },
  MAPOS: {
    integrations: [
      IntegrationCodeEnum.MAPOS_MASTORE,
      IntegrationCodeEnum.LYPRO_TEST,
    ],
    workflows: ["NONE", "MAPOS_RESTAURANT"],
  },
};

export const WORKFLOW_LABELS: Record<AgentWorkflow, string> = {
  NONE: "Conversación normal (sin workflow)",
  MAPOS_RESTAURANT: "MAPOS restaurante",
  LOANS: "Créditos (Loans)",
  EXTERNAL_BOT: "Bot externo (MAPOS)",
  LYPRO_TRAVEL: "Atención de solicitudes Travel",
};
